export const tr = {
    addMoney: 'Ödeme yap',
    moneyBlocked: 'Bakiye engellendi',
    needPayment: 'Kampanyadaki bakiye bitmek üzere. Lütfen, bakiye ekleyin.'
};
